<div class="page">
  <div class="header">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Pacientes en espera</h1>

      <!-- @if (esEnfermero) {
        <span class="rol-indicador">Enfermería</span>
      } -->
    </div>
  </div>

  @if (pendientesOrdenados.length === 0) {
    <div class="sin-datos">
      <mat-icon class="material-symbols-outlined"> patient_list </mat-icon>

      <h2>No hay pacientes en espera</h2>
    </div>
  } @else {
    <mat-dialog-content>
      <div class="detail-body">
        <!-- ENCABEZADOS -->
        <div
          class="patient-header"
          [class.enfermeria]="esEnfermero"
          [class.personal-medico]="esMedicoOAdmin"
        >
          <span>Prioridad</span>
          <span>Paciente</span>
          <span>Hora</span>
          <span>Signos</span>

          @if (esMedicoOAdmin) {
            <span>Consulta</span>
          }

          <span>Cancelar</span>
        </div>

        @for (p of pendientesOrdenados; track p.id) {
          <div
            class="patient"
            [class.enfermeria]="esEnfermero"
            [class.personal-medico]="esMedicoOAdmin"
          >
            <!-- PRIORIDAD -->
            <span
              class="prioridad"
              [ngClass]="p.prioridad"
              [matTooltip]="'Prioridad: ' + p.prioridad"
            ></span>

            <!-- PACIENTE -->
            <strong
              [matTooltip]="
                (p.paciente?.nombre || '') +
                ' ' +
                (p.paciente?.apellido || '') +
                ' ' +
                (p.paciente?.segundoApellido || '')
              "
            >
              {{ p.paciente?.nombre }}
              {{ p.paciente?.apellido }}
              {{ p.paciente?.segundoApellido }}
            </strong>

            <!-- HORA -->
            <span class="hora">
              {{ p.horaLlegada | date: 'HH:mm' }}
            </span>

            <!-- SIGNOS VITALES -->
            <button
              mat-icon-button
              color="accent"
              (click)="abrirGragicaSignosVitales(p)"
              matTooltip="Ver historial de signos vitales"
            >
              <mat-icon>monitor_heart</mat-icon>
            </button>

            <!-- CONSULTA: SOLO MÉDICO / ADMIN -->
            @if (esMedicoOAdmin) {
              <button
                mat-icon-button
                color="accent"
                (click)="abrirConsulta(p)"
                matTooltip="Enviar a consulta"
              >
                <mat-icon>send</mat-icon>
              </button>
            }

            <!-- CANCELAR: ENFERMERÍA, MÉDICO Y ADMIN -->
            <button
              mat-icon-button
              class="cancelar-btn"
              (click)="cancelarAtencion(p)"
              matTooltip="Cancelar atención"
              aria-label="Cancelar atención del paciente"
            >
              <mat-icon>cancel_schedule_send</mat-icon>
            </button>
          </div>
        }
      </div>
    </mat-dialog-content>
  }
</div>
